import { createContext, useState } from "react";

const initialValue = { isCollapsed: true, toggleSidebarcollapse: () => {} };

interface ProvideSidebarContext {
  toggleSidebarcollapse: () => void,
  isCollapsed: boolean
}
const SidebarContext = createContext<ProvideSidebarContext>(initialValue);

const SidebarProvider = ({ children }: { children: React.ReactNode }) => {
  const [isCollapsed, setCollapse] = useState(true);

  const toggleSidebarcollapse = () => {
    setCollapse((prevState) => !prevState);
  };

  return (
    <SidebarContext.Provider value={{ isCollapsed, toggleSidebarcollapse }}>
      {children}
    </SidebarContext.Provider>
  );
};

export { SidebarContext, SidebarProvider };